export function tCodeOptions(state) {
  return state.tCodeOptions;
}